<form style="max-width: 400px">
    <h1 style="display: flex; justify-content: space-between" class="h4 signin-title">
        Two-Factor Authentication
        @if (!this.force2fa) {
            <div (click)="!enrolled ? showQr(qrTmpl) : showDisable(disableTmpl)">
                <app-toggle-switch onLabel="On" offLabel="Off" [checked]="enrolled" [autoToggle]="false">
                </app-toggle-switch>
            </div>
        }
    </h1>
    @if (enrolled) {
        Your account is currently enrolled in Two-Factor Authentication
        @if (!this.force2fa) {
            <button
                (click)="showDisable(disableTmpl)"
                class="btn btn-lg btn-primary btn-block"
                style="margin-top: 16px">
                Disable Two-Factor Authentication
            </button>
        }
        @if (this.force2fa) {
            <button (click)="showReset(resetTmpl)" class="btn btn-lg btn-primary btn-block" style="margin-top: 16px">
                Reset Two-Factor Authentication
            </button>
        }
    } @else {
        <div style="margin-bottom: 15px">
            Follow the instructions below to setup TOTP Two-Factor Authentication using an Authenticator App.
        </div>
        <ul>
            <li>
                First,
                <a
                    target="_blank"
                    rel="noopener noreferer"
                    href="https://www.microsoft.com/en-us/security/mobile-authenticator-app"
                    >Download Microsoft Authenticator for iOS / Android</a
                >
            </li>
            <li>Next, Press <b>Setup Two-Factor Authentication</b> below</li>
        </ul>
        <button (click)="showQr(qrTmpl)" class="btn btn-lg btn-primary btn-block mt-3">
            Setup Two-Factor Authentication
        </button>
    }
    <ng-template #notEnrolled>
        <div style="margin-bottom: 15px">
            Follow the instructions below to setup TOTP Two-Factor Authentication using an Authenticator App.
        </div>
        <ul>
            <li>
                First,
                <a
                    target="_blank"
                    rel="noopener noreferer"
                    href="https://www.microsoft.com/en-us/security/mobile-authenticator-app"
                    >Download Microsoft Authenticator for iOS / Android</a
                >
            </li>
            <li>Next, Press <b>Setup Two-Factor Authentication</b> below</li>
        </ul>
        <button (click)="showQr(qrTmpl)" class="btn btn-lg btn-primary btn-block mt-3">
            Setup Two-Factor Authentication
        </button>
    </ng-template>
</form>

<!-- Disable Modal -->
<ng-template #disableTmpl>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-title">Disable Two-Factor Authentication</h4>
        <button type="button" class="close" aria-describedby="modal-title" (click)="modal.dismissAll()">
            <span aria-hidden="true" style="font-size: 1.5rem">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label for="code">Enter 6 Digit Code:</label>
            <input
                name="code"
                id="code"
                [(ngModel)]="code"
                type="text"
                class="form-control"
                autocomplete="one-time-code" />
        </div>
        <div class="form-group">
            <label for="confirmCode">Confirm 6 Digit Code:</label>
            <input name="confirmCode" id="confirmCode" type="text" [(ngModel)]="confirmCode" class="form-control" />
        </div>
        @if (codeError) {
            <span class="text-danger">{{ codeError }}</span>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="disable()">Disable</button>
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismissAll()">Cancel</button>
    </div>
</ng-template>

<!-- Reset Modal -->
<ng-template #resetTmpl>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-title">Reset Two-Factor Authentication</h4>
        <button type="button" class="close" aria-describedby="modal-title" (click)="modal.dismissAll()">
            <span aria-hidden="true" style="font-size: 1.5rem">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div>
            <p>
                This will reset your two-factor authentication method, but not disable it. After entering a valid code,
                you'll be prompted to set it up again.
            </p>
            <p>
                If you are unable to provide a code with the currently configured device or app, please contact your
                site administrator or
                <a href="https://support.sedonatek.com/" target="_blank">support</a>.
            </p>
        </div>
        <div class="form-group">
            <label for="code">Enter 6 Digit Code:</label>
            <input
                name="code"
                id="code"
                [(ngModel)]="code"
                type="text"
                class="form-control"
                autocomplete="one-time-code" />
        </div>
        @if (codeError) {
            <span class="text-danger">{{ codeError }}</span>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="reset()">Reset</button>
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismissAll()">Cancel</button>
    </div>
</ng-template>

<!-- Enable Modal -->
<ng-template #qrTmpl>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-title">Setup Two-Factor Authentication</h4>
        @if (!this.force2fa) {
            <button type="button" class="close" aria-describedby="modal-title" (click)="modal.dismissAll()">
                <span aria-hidden="true" style="font-size: 1.5rem">&times;</span>
            </button>
        }
    </div>
    <div class="modal-body">
        @if (this.force2fa) {
            <div class="label" style="color: red; font-size: larger">** Two-factor authentication is required.</div>
        }
        @if (this.force2fa && !this.enrolled) {
            <div>&nbsp;</div>
        }
        <ol style="padding-left: 15px">
            <li>
                First,
                <a
                    target="_blank"
                    rel="noopener noreferer"
                    href="https://www.microsoft.com/en-us/security/mobile-authenticator-app"
                    >Download Microsoft Authenticator for iOS / Android</a
                >
            </li>
            <li>Press the Add (+) button at the top right of the Microsoft Authenticator App</li>
            <li>Choose "Other Account"</li>
            <li>Scan the QR Code below</li>
        </ol>
        <qrcode [qrdata]="$safeNavigationMigration(codeDto?.Qr)" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
        <code style="display: inline-block; width: auto; margin-left: 15px; margin-bottom: 15px; margin-top: -4px">{{
            codeDto?.Key
        }}</code>
        <nz-icon nzType="copy" nzTheme="outline" (click)="copyToClipboard($safeNavigationMigration(codeDto?.Key))" />
        <div class="form-group">
            <label for="code1" class="control-label">4. Enter 6 Digit Code:</label>
            <input name="code1" [(ngModel)]="code" type="text" class="form-control" />
        </div>
        <div class="form-group">
            <label for="code2" class="control-label">5. Confirm 6 Digit Code:</label>
            <input name="code2" type="text" [(ngModel)]="confirmCode" class="form-control" />
        </div>
        @if (codeError) {
            <span class="text-danger">{{ codeError }}</span>
        }
    </div>
    <div class="modal-footer">
        @if (this.force2fa) {
            <button type="button" class="btn btn-outline-secondary btn-warning pull-left" (click)="logout()">
                Logout
            </button>
        }
        <button type="button" class="btn btn-primary" (click)="finish()">Finish Setup</button>
        @if (!this.force2fa) {
            <button type="button" class="btn btn-outline-secondary" (click)="modal.dismissAll()">Cancel</button>
        }
    </div>
</ng-template>
